<!--
 * @Author: DY
 * @Date: 2020-08-17 22:01:34
 * @LastEditTime: 2022-02-07 16:09:57
 * @LastEditors: Please set LastEditors
 * @Description: 关联配比
 * @FilePath: \JT_Mobile_test\src\views\salesTerminal\productionRatio\correlationRatio.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="correlationRatio">
            <van-nav-bar
                title="关联配比"
                left-text="生产配比"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <div class="head">
                    <div class="headContent">
                        <div class="headinfo">
                            <h4>任务编号：{{ task_number }}</h4>
                            <p>
                                <strong class="van_left">{{ productFormula.project_name }}</strong>
                                <span class="van_right">{{ productFormula.place_detail }}</span>
                            </p>
                            <ul>
                                <li>{{ productFormula.strength_grade_name }}</li>
                                <li>{{ productFormula.slump }}</li>
                                <li>{{ productFormula.pouring_name }}</li>
                                <li>{{ productFormula.special_require_name }}</li>
                            </ul>
                        </div>
                        <div class="headBtn">
                            <div>
                                <p>是否出资料：</p>
                                <van-switch
                                    v-model="productFormula.is_datum"
                                    size="20px"
                                    @change="saveProductFormula"
                                    :disabled="editReadOnly"
                                ></van-switch>
                            </div>
                            <div>
                                <p>产生抗压试验：</p>
                                <van-switch
                                    v-model="productFormula.is_testblock"
                                    size="20px"
                                    @change="saveProductFormula"
                                    :disabled="editReadOnly"
                                ></van-switch>
                            </div>
                            <div>
                                <p>试块组数：</p>
                                <input
                                    type="number"
                                    v-model="productFormula.block_group"
                                    @change="saveProductFormula"
                                    placeholder="请输入"
                                    :disabled="editReadOnly"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <van-tabs :line-width="70" v-model="mixstationlineIndex">
                    <template v-for="(item, index) in mixstationlineData">
                        <van-tab :key="index">
                            <template #title>
                                {{ item.line_name }}
                                <i class="icon toSave" v-if="item.product_formula_number_hjt && !item.sync_status"></i>
                                <i class="icon toSend" v-if="item.sync_status"></i>
                            </template>
                        </van-tab>
                    </template>
                </van-tabs>
                <div class="mixtureRatio">
                    <h5>选择配合比类型：</h5>
                    <van-radio-group v-model="formulaTypeVal" direction="horizontal" icon-size="16">
                        <template v-for="(item,index) in formulaTypeData">
                            <van-radio :name="item.value" :key="index">
                                {{ item.label }}
                            </van-radio>
                        </template>
                    </van-radio-group>
                </div>
                <div class="scrollArea">
                    <div class="selectRatioInfo">
                        <div>
                            <div class="experimentalRatioNo">
                                试验配比名称：{{ productFormulaCount.experiment_formula_name }}
                            </div>
                            <div class="experimentalRatioNo">
                                试验配比编号：{{ productFormulaCount.line_experiment_formula_number }}
                            </div>
                        </div>
                        <div>
                            <div class="selectRatioBtn" @click="chooseRatioClick">
                                <p>选择配比</p>
                                <i class="iconfont iconjiantouxia"></i>
                            </div>
                            <van-action-sheet
                                v-model="actionsShow"
                                :actions="actions"
                                cancel-text="取消"
                                @select="onSelect"
                            ></van-action-sheet>
                        </div>
                    </div>
                    <div class="proportion">
                        <div>
                            <h5>设计容重</h5>
                            <p>
                                <strong>{{ productFormulaCount.design_volume_weight || 0 }}</strong>
                                <span>kg</span>
                            </p>
                        </div>
                        <div>
                            <h5>实际容重</h5>
                            <p>
                                <strong>{{ productFormulaCount.practical_volume_weight || 0 }}</strong>
                                <span>kg</span>
                            </p>
                        </div>
                        <div style="width: 28%;">
                            <h5>坍落度</h5>
                            <p>
                                <strong>{{ productFormulaCount.slump || 0 }}</strong>
                                <span>mm</span>
                            </p>
                        </div>
                        <div style="width: 22%;">
                            <h5>水胶比</h5>
                            <p>
                                <strong>{{ productFormulaCount.water_binder_ratio || 0 }}</strong>
                                <span>%</span>
                            </p>
                        </div>
                        <div>
                            <h5>砂率</h5>
                            <p>
                                <strong>{{ productFormulaCount.sand_rate || 0 }}</strong>
                                <span>%</span>
                            </p>
                        </div>
                        <div>
                            <h5>最大粒径</h5>
                            <p>
                                <strong>{{ productFormulaCount.max_particle_size || 0 }}</strong>
                                <span>mm</span>
                            </p>
                        </div>
                        <div style="width: 28%;">
                            <h5>胶凝材料</h5>
                            <p>
                                <strong>{{ productFormulaCount.cementing_material || 0 }}</strong>
                            </p>
                        </div>
                        <div style="width: 22%;">
                            <h5>外加剂掺量</h5>
                            <p>
                                <strong>{{ productFormulaCount.admixture_dosage || 0 }}</strong>
                                <span>%</span>
                            </p>
                        </div>
                    </div>
                    <dl class="matchingInfo">
                        <dt>
                            <p>配比信息</p>
                            <span>（点击料仓设置配比信息）</span>
                        </dt>
                        <dd>
                            <template v-for="(item, index) in matchingInfoData">
                                <div :key="index" @click="openPage(item,index)">
                                    <p class="name">
                                        <strong>{{ item.plcw || '-' }}/{{ item.plcwname || '-' }}</strong>
                                    </p>
                                    <p class="value">
                                        <span class="amount">量:{{ item.product_quantity || 0 }}</span>
                                        <span class="waterContent" v-if="item.stock_category == 'F3-01-XN-01'">
                                            含水率:{{ item.moisture_ratio || 0 }}%
                                        </span>
                                    </p>
                                    <p class="materialScience">
                                        {{ item.stock_category_name || '-' }}/{{ item.material_child_name || '-' }}/{{ item.material_name || '-' }}
                                    </p>
                                </div>
                            </template>
                        </dd>
                    </dl>
                </div>
            </section>
            <footer :class="{'hideOpinion': !isShowOpinion}">
                <button
                    class="iconfont iconfujian-fill opinionButton"
                    @click="openApprovalComments"
                    v-if="isShowOpinion"
                >
                    意见
                </button>
                <div>
                    <van-button
                        class="iconfont iconbaocun-tianchong"
                        @click="saveLine"
                        :loading="saveLoading"
                        type="info"
                        loading-text="保存中..."
                    >
                        保存
                    </van-button>
                    <van-button
                        class="iconfont iconsend"
                        @click="sendOutClick"
                        :loading="sendOutLoading"
                        type="info"
                        loading-text="发送中..."
                    >
                        发送
                    </van-button>
                </div>
            </footer>
            <van-popup v-model="selectCrewShow">
                <div class="selectCrew">
                    <h3>选择要发送的机组</h3>
                    <ul>
                        <template v-for="(item,index) in mixstationlineData">
                            <li
                                :key="index"
                                :class="[{'associated': item.product_formula_number_hjt}]"
                                @click="selectProductionLine(item,item.product_formula_number_hjt,$event)"
                            >
                                <div class="crewName van_left">
                                    <span class="iconfont iconjiaobiao1 cornerMarker cornerMarker_l">
                                        <i class="iconfont iconduigou"></i>
                                    </span>
                                    <span class="name">{{ item.line_name }}</span>
                                </div>
                                <div class="crewDetails van_left">
                                    <p>
                                        <i></i>
                                        <span>砼配比编号：{{ item.product_formula_number_hjt }}</span>
                                    </p>
                                    <p>
                                        <i></i>
                                        <span>润泵砂浆编号：{{ item.product_formula_number_sj }}</span>
                                    </p>
                                    <span class="iconfont iconjiaobiao cornerMarker cornerMarker_r">
                                        <i v-if="item.product_formula_number_hjt">已关联</i>
                                        <i v-else>未关联</i>
                                    </span>
                                </div>
                            </li>
                        </template>
                    </ul>
                    <div class="btns">
                        <button class="iconfont iconsend" @click="sendOut">
                            发送
                        </button>
                    </div>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
import NP from 'number-precision';

export default {
    // 关联配比
    name: 'correlation-ratio',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/productionRatio') {
            this.$store.commit('noKeepAlive', 'correlation-ratio');
        }
        next();
    },
    data() {
        return {
            // 编辑只读（显示所有操作按钮，没有操作权限）
            editReadOnly: false,

            // 任务单号
            task_number: '',
            // 任务列表下标
            listIndex: 0,
            // 施工配比基本信息
            productFormula: {
                // 工程名称 
                project_name: '',
                // 工程部位
                place_detail: '',
                // 是否出资料
                is_datum: false,
                // 产生抗压试验
                is_testblock: false,
            },
            // 全部生产机组
            mixstationlineData: [],
            // 当前选中机组下标
            mixstationlineIndex: 0,
            // 当前选中机组
            mixstationChecked: null,
            // 全部配比类型
            formulaTypeData: [
                {
                    label: '砼配比',
                    value: 0,
                },
                {
                    label: '润泵砂浆配比',
                    value: 1,
                },
                {
                    label: '润泵砂浆配比(标号)',
                    value: 2,
                },
            ],
            // 配比类型绑定字段
            formulaTypeVal: 0,
            // 选中配合比类型
            formulaTypeChecked: 0,
            // 配比类型层状态
            actionsShow: false,
            // 配比类型待选项
            actions: [{
                name: '试验配比',
                type: 0,
            }, {
                name: '配比同步',
                type: 2,
            }],
            // 选择配比类型（0试验配比，1原试验配比）
            selectRatioType: null,
            // 选择机组弹出层状态
            selectCrewShow: false,
            // 机组下基础信息
            productFormulaCount: {},
            // 配比信息数据
            matchingInfoData: [],
            // 需要发送的机组
            syncStatus: [],
            // 审批意见按钮权限
            isShowOpinion: false,
            // 保存按钮状态
            saveLoading: false,
            // 发送按钮状态
            sendOutLoading: false,
        };
    },
    created() {
        // 任务单号
        this.task_number = this.$route.params.task_number;
        // 任务列表下标
        this.listIndex = this.$route.params.listIndex;
        // 初始化页面数据
        this.getInit();
    },
    mounted() { },
    activated() {
        // 配比类型层状态
        this.actionsShow = false;
        // 有selectMatchingData是选择配比返回
        if (this.$route.params.selectMatchingData) {
            // 选择配比回调
            this.additionalCallback(this.$route.params.selectMatchingData);
        }
        // 有matchingInfo是编辑配比返回
        if (this.$route.params.matchingInfo) {
            this.matchingInfoData[this.$route.params.index] = this.$route.params.matchingInfo;
            this.productFormulaCount.productFormulaRelExperimentOutputs[this.$route.params.index] = this.$route.params.matchingData;
            if (this.matchingInfoData[this.$route.params.index].stock_category === 'F3-01-XN-01') {
                // 计算水施工配比用量
                this.calculationWaterConsumption();
            }
            // 计算基本信息（容重、水胶比、砂率、外加剂掺量、胶凝材料）
            this.calculation_BasicInfoValue();
        }
        // 同步成功返回
        if (this.$route.params.synchronousReturn) {
            // 初始化页面数据
            this.getInit();
        }
    },
    update() { },
    beforeRouteUpdate() { },
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 初始化页面数据
        getInit() {
            this.$axios
                .get(`/interfaceApi/production/productformula/formulawithline/${this.task_number}`)
                .then(res => {
                    if (res.productFormula.is_approval_formula) {
                        this.isShowOpinion = true;
                    }

                    if (res.productFormula.formula_approval_status === 0) {
                        this.editReadOnly = true;
                    }

                    // 基本信息赋值
                    this.productFormula = res.productFormula;
                    // 生产机组赋值
                    this.mixstationlineData = res.productFormulaLine;
                    if (!this.mixstationChecked) {
                        this.mixstationChecked = this.mixstationlineData[0].line_code;
                        this.mixstationChange();
                    }
                    this.syncStatus = [];
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 过滤当前产线数据
        mixstationChange() {
            const tableData = this.mixstationlineData.filter(item => {
                return item.line_code === this.mixstationChecked;
            });
            if (tableData.length > 0) {
                if (this.formulaTypeChecked === 0) {
                    if (tableData[0].product_formula_hjt) {
                        this.productFormulaCount = tableData[0].product_formula_hjt;
                        this.matchingInfoData = tableData[0].product_formula_hjt.productFormulaEntityOutputs;
                    } else {
                        this.matchingInfoData = [];
                        this.productFormulaCount = {};
                    }
                } else if (this.formulaTypeChecked === 1) {
                    if (tableData[0].product_formula_sj) {
                        this.productFormulaCount = tableData[0].product_formula_sj;
                        this.matchingInfoData = tableData[0].product_formula_sj.productFormulaEntityOutputs;
                    } else {
                        this.matchingInfoData = [];
                        this.productFormulaCount = {};
                    }
                }
            } else {
                this.matchingInfoData = [];
                this.productFormulaCount = {};
            }
            if ((this.productFormulaCount.productFormulaRelExperimentOutputs || []).length > 0) {
                this.selectRatioType = 0;
            } else {
                this.selectRatioType = 1;
            }
        },
        // 保存施工配比基本信息
        saveProductFormula() {
            this.$axios
                .post(
                    '/interfaceApi/production/productformula/save',
                    this.productFormula
                )
                .then(() => {
                    this.$toast('保存成功!');
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 选择配比按钮点击
        chooseRatioClick() {
            if (this.editReadOnly) {
                return;
            }
            this.actionsShow = true;
        },
        // 选择配比类型
        onSelect(item) {
            if (item.type === 2) {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'synchronization',
                    params: {
                        lineData: this.mixstationlineData[this.mixstationlineIndex],
                        productFormulaNumber: this.productFormulaCount.product_formula_number,
                    },
                });
            } else {
                const newCode = {
                    selectRatioType: item.type,
                    line_code: this.mixstationChecked,
                    formula_type: this.formulaTypeChecked,
                    station_id: this.productFormula.station_id,
                    strength_grade: this.productFormula.strength_grade,
                };
                if (this.formulaTypeVal === 2) {
                    newCode.is_filter_mark = true;
                }
                this.actionsShow = false;
                this.$router.isBack = 2;
                this.selectRatioType = item.type;
                this.$router.push({
                    name: 'selectRatio',
                    params: newCode,
                });
            }
        },
        // 添加实验配比回调
        additionalCallback(data) {
            let getUrl = '';
            const callbackData = data;
            callbackData.product_formula_number = this.productFormulaCount.product_formula_number;
            this.productFormulaCount = callbackData;
            if (this.selectRatioType) {
                getUrl = `/interfaceApi/production/standardformula/choose_experiment_formula/${callbackData.line_experiment_formula_number}`;
            } else {
                getUrl = '/interfaceApi/production/experimentformula/choose_experiment_formula/'
                + `${this.mixstationChecked}/${callbackData.experiment_formula_number}/${callbackData.versions}`;
            }
            this.$axios
                .get(getUrl)
                .then(res => {
                    this.productFormulaCount = res;
                    this.matchingInfoData = res.productFormulaEntityOutputs;
                    // 计算基本信息（容重、水胶比、砂率、外加剂掺量、胶凝材料）
                    this.calculation_BasicInfoValue();
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 打开料仓配比信息设置
        openPage(data, index) {
            let matchingData = null;
            if (this.selectRatioType === 0) {
                // eslint-disable-next-line max-len
                matchingData = this.productFormulaCount.productFormulaRelExperimentOutputs.filter(item => item.stock_category === data.stock_category)[0];
            }
            let isReadOnly = false;
            if (this.editReadOnly) {
                isReadOnly = true;
            }
            this.$router.isBack = 2;
            this.$router.push({
                name: 'matchingInfoSetting',
                params: {
                    isReadOnly: isReadOnly,
                    data: data,
                    matchingData: matchingData,
                    index: index,
                },
            });
        },
        // 计算水施工配比用量（细骨料修改含水率计算第一个水的施工配比用量）
        calculationWaterConsumption() {
            // 细骨料含水量
            let waters = 0;
            // 水
            const waterList = this.matchingInfoData.filter(item => item.stock_category === 'F3-01-XN-03');
            // 细骨料
            const fineAggregateList = this.matchingInfoData.filter(item => item.stock_category === 'F3-01-XN-01');
            if (fineAggregateList.length > 0) {
                fineAggregateList.forEach(z => {
                    waters += NP.times(z.experiment_quantity || 0, NP.divide(z.moisture_ratio || 0, 100));
                });
            }
            if (waterList.length > 0) {
                waterList[0].product_quantity = NP.minus(waterList[0].experiment_quantity || 0, waters);
            }
        },
        // 计算基本信息（容重、水胶比、砂率、外加剂掺量、胶凝材料）
        calculation_BasicInfoValue() {
            let practical_volume_weight = 0; // 容重
            let fineAggregate = 0; // 细骨料
            let coarseAggregate = 0; // 粗骨料
            let water = 0; // 水
            let powder = 0; // 粉料
            let cement = 0; // 水泥
            let admixtures = 0; // 掺合料（分类，字典值205-开头的）
            let powderyExpansiveAgent = 0; // 粉状膨胀剂（规格：外加剂-膨胀剂-粉状膨胀剂）
            let admixture = 0; // 外加剂(排除粉状膨胀剂)
            this.matchingInfoData.forEach(k => {
                practical_volume_weight += Number(Number(k.product_quantity || 0).toFixed(2)) * 100;
                if (k.stock_category_dictcode === '203') {
                    fineAggregate += Number(k.product_quantity);
                }
                if (k.stock_category_dictcode === '204') {
                    coarseAggregate += Number(k.product_quantity);
                }
                if (k.stock_category_dictcode === '207') {
                    water += Number(k.product_quantity);
                }
                // eslint-disable-next-line max-len
                if (['202', '205-FHL', '205-GHJ', '205-FMH', '205-GH0', '205-GZF', '205-KZF', '205-LZF', '205-SHF'].indexOf(k.stock_category_dictcode) > -1) {
                    powder += Number(k.product_quantity);
                }
                if (k.stock_category_dictcode === '202') {
                    cement = NP.plus(cement, k.product_quantity || 0);
                }

                if (k.stock_category_dictcode.indexOf('205-') > -1) {
                    admixtures = NP.plus(admixtures, k.product_quantity || 0);
                }

                if (k.stock_category_dictcode === '208') {
                    if (k.material_child_dictcode === '208-PZJ' && k.material_code === '208-PZJ-01') {
                        powderyExpansiveAgent = k.product_quantity;
                    }
                    if (k.material_code !== '208-PZJ-01') {
                        admixture = NP.plus(admixture, k.product_quantity || 0);
                    }
                }

            });
            // 砂率
            if (fineAggregate > 0) {
                // eslint-disable-next-line max-len
                this.productFormulaCount.sand_rate = Number(NP.times(NP.divide(fineAggregate, NP.plus(fineAggregate, coarseAggregate)), 100)).toFixed(2);
            } else {
                this.productFormulaCount.sand_rate = 0;
            }

            // 水胶比
            if (water > 0 && powder > 0) {
                this.productFormulaCount.water_binder_ratio = Number(NP.times(NP.divide(water, powder), 100)).toFixed(2);
            } else {
                this.productFormulaCount.water_binder_ratio = 0;
            }

            // 容重
            this.productFormulaCount.practical_volume_weight = Number(NP.divide(practical_volume_weight, 100)).toFixed(2);

            // 胶凝材料
            this.productFormulaCount.cementing_material = Number(NP.plus(cement, admixtures, powderyExpansiveAgent));

            // 外加剂掺量
            if (this.productFormulaCount.cementing_material) {
                // eslint-disable-next-line max-len
                this.productFormulaCount.admixture_dosage = Number(NP.times(NP.divide(admixture, this.productFormulaCount.cementing_material), 100)).toFixed(2);
            } else if (admixture > 0) {
                this.productFormulaCount.admixture_dosage = 100;
            } else {
                this.productFormulaCount.admixture_dosage = 0;
            }
        },
        // 审批意见
        openApprovalComments() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'mixtureRatioApprovalOpinion',
                params: {
                    task_number: this.task_number,
                },
            });
        },
        // 保存
        saveLine() {
            if (this.editReadOnly) {
                return;
            }
            this.saveLoading = true;
            const productFormulaLine = {
                task_number: this.task_number, // 任务单号
                formula_type: this.formulaTypeChecked, // 配方类型
                line_code: this.mixstationChecked, // 生产线编码
                product_formula_number: this.productFormulaCount.product_formula_number || '', // 施工配比编号
                line_experiment_formula_number: this.productFormulaCount.line_experiment_formula_number || '', // 生产线实验配比编号
                experiment_formula_name: this.productFormulaCount.experiment_formula_name,
                design_volume_weight: this.productFormulaCount.design_volume_weight || '', // 设计容重
                slump: this.productFormulaCount.slump || '', // 坍落度
                water_binder_ratio: this.productFormulaCount.water_binder_ratio || '', // 水胶比
                sand_rate: this.productFormulaCount.sand_rate || '', // 砂率
                max_particle_size: this.productFormulaCount.max_particle_size || '', // 最大粒径
                practical_volume_weight: this.productFormulaCount.practical_volume_weight, // 实际容重
            };
            // 获取当前选中生产线
            const newLin = this.mixstationlineData.filter(item => {
                return item.line_code === this.mixstationChecked;
            })[0];
            // 生产线名称
            productFormulaLine.line_name = newLin.line_name;
            // 生产拌台
            productFormulaLine.scbt = newLin.scbt;
            // 排序字段
            productFormulaLine.sort_num = newLin.sort_num;

            const productFormulaEntity = JSON.parse(
                JSON.stringify(this.matchingInfoData).replace(
                    /^version$/g,
                    'industry_silo_version'
                )
            );
            this.$axios
                .post('/interfaceApi/production/productformula/save_line',
                    {
                        productFormulaLine: productFormulaLine,
                        productFormulaEntity: productFormulaEntity,
                        productFormulaRelExperiments: this.productFormulaCount.productFormulaRelExperimentOutputs,
                    }
                )
                .then(res => {
                    this.saveLoading = false;
                    this.$toast('保存成功!');
                    this.productFormulaCount.product_formula_number = res.formula_number;
                    this.getInit();
                })
                .catch(error => {
                    this.saveLoading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 发送按钮点击
        sendOutClick() {
            if (this.editReadOnly) {
                return;
            }
            this.selectCrewShow = true;
        },
        // 选择产线
        selectProductionLine(data, type, event) {
            if (type) {
                const el = event.currentTarget;
                if (el.getAttribute('class').indexOf('active') === -1) {
                    el.classList.add('active');
                } else {
                    el.classList.remove('active');
                }
                this.syncStatus.push(data.line_code);
            } else {
                this.$toast('选择产线未关联!');
            }
        },
        // 发送
        sendOut() {
            this.sendOutLoading = true;
            this.selectCrewShow = false;
            this.$axios
                .post('/interfaceApi/production/productformula/send',
                    {
                        task_number: this.task_number,
                        send_line_code: this.syncStatus,
                    }
                )
                .then(res => {
                    if (res) {
                        if (res.is_control) {
                            let text = '管控提醒';
                            if (res.msg_title) {
                                text = res.msg_title;
                            }
                            this.$dialog.alert({
                                title: text,
                                message: `${res.control_msg}`,
                            }).then(() => {
                                this.$router.isBack = 1;
                                this.$router.replace({
                                    name: 'productionRatio',
                                    params: {
                                        index: this.listIndex,
                                    },
                                });
                                this.$router.go(-1);
                            });
                        } else {
                            this.$toast('发送成功！');
                            this.$router.isBack = 1;
                            this.$router.replace({
                                name: 'productionRatio',
                                params: {
                                    index: this.listIndex,
                                },
                            });
                            this.$router.go(-1);
                        }
                    }
                    this.sendOutLoading = false;
                })
                .catch(error => {
                    this.sendOutLoading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    filter: {},
    computed: {},
    watch: {
        mixstationlineIndex(newVal) {
            this.mixstationChecked = this.mixstationlineData[newVal].line_code;
            this.mixstationChange();
        },
        formulaTypeVal(newVal) {
            if (newVal === 0) {
                this.formulaTypeChecked = 0;
            } else if ([1, 2].indexOf(newVal) > -1) {
                this.formulaTypeChecked = 1;
            }
        },
        formulaTypeChecked() {
            this.mixstationChange();
        },
    },
};
</script>

<style lang="stylus" scoped>
.correlationRatio
    height 100%
    section
        height calc(100% - 114rpx)
        .head
            height 160rpx
            position relative
            &:after
                height 92rpx
                content ''
                position absolute
                top 0
                left 0
                width 100%
                background #1F2229
            .headContent
                width 345rpx
                height 159rpx
                background url(images/bg@2x.png) no-repeat
                background-size 100% 100%
                position absolute
                top 0
                left 50%
                transform translateX(-50%)
                z-index 9
                .headinfo
                    height 92rpx
                    padding 10rpx 15rpx
                    h4
                        font-size 16rpx
                        color #3495FB
                    p
                        overflow hidden
                        line-height 32rpx
                        strong
                            font-size 16rpx
                            font-weight 500
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            width 60%
                        span
                            font-size 14rpx
                            color #666666
                            text-align right
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            width 30%
                    ul
                        overflow hidden
                        li
                            float left
                            width 60rpx
                            font-size 12rpx
                            line-height 20rpx
                            margin-right 10rpx
                            text-align center
                            &:nth-of-type(1)
                                color #5588F1
                                background rgba(85,136,241,0.06)
                            &:nth-of-type(2)
                                color #FA8436
                                background rgba(250,132,54,0.06)
                            &:nth-of-type(3)
                                color #21BDCC
                                background rgba(33,189,204,0.06)
                            &:nth-of-type(4)
                                color #866BEE
                                background rgba(134,107,238,0.06)
                .headBtn
                    display flex
                    padding 8rpx 15rpx 0
                    >div
                        flex 4
                        p
                            font-size 14rpx
                            line-height 14rpx
                            margin-bottom 7rpx
                            color #333333
                            white-space nowrap
                        input
                            width 60rpx
                            height 30rpx
                            font-size 14rpx
                            text-align center
                            border 1px solid #D7D7D7
                        &:nth-of-type(3)
                            flex 2
                            p
                                margin-bottom 2rpx
        .van-tabs
            width 100%
            .van-tab__text
                i
                    display inline-block
                    width 20rpx
                    height 20rpx
                    &.toSave
                        background url(images/save@2x.png) no-repeat
                        background-size 100% 100%
                    &.toSend
                        background url(images/send@2x.png) no-repeat
                        background-size 100% 100%
        .mixtureRatio
            width 100%
            height 60rpx
            padding 10rpx 15rpx 0 15rpx
            font-size 14rpx
            color #333333
            overflow hidden
            h5
                margin-bottom 6rpx
            .van-radio-group
                justify-content space-between
                .van-radio
                    margin-right 0
                    .van-icon
                        font-size 16rpx
                    .van-radio__label
                        font-size 14rpx
                        line-height 16rpx
        .scrollArea
            height calc(100% - 260rpx)
            overflow-y auto
            .selectRatioInfo
                padding 0 14rpx
                display flex
                justify-content space-between
                >div
                    &:nth-of-type(1)
                        width calc(100% - 100rpx)
                    &:nth-of-type(2)
                        width 93rpx
                .experimentalRatioNo
                    font-size 14rpx
                    line-height 14rpx
                    margin 10rpx 0
                    color #666666
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                .selectRatioBtn
                    width 100%
                    height 34rpx
                    margin 8rpx 0
                    border-radius 4px
                    border 1px solid #3094FB
                    text-align center
                    color #3094FB
                    font-size 14rpx
                    p,i
                        display inline-block
                        font-size 14rpx
                        line-height 32rpx
                        color #3094FB
                    i
                        margin-left 5rpx
            .proportion
                margin 0 14rpx
                height 90rpx
                padding 0 10rpx
                background rgba(255,255,255,1)
                box-shadow 1px 1px 4px 0px rgba(85,136,241,0.5)
                border-radius 4px
                border 1px solid rgba(215,215,215,1)
                display flex
                flex-wrap wrap
                justify-content space-between
                >div
                    width 25%
                    margin 5rpx 0
                    h5
                        font-size 10rpx
                        color #979EA7
                        line-height 15rpx
                        margin-bottom 3rpx
                    p
                        line-height 14rpx
                        strong
                            font-size 14rpx
                            font-weight 400
                        span
                            font-size 10rpx
                    &:nth-of-type(1)
                        p
                            color #5588F1
                    &:nth-of-type(2)
                        p
                            color #EB656F
                    &:nth-of-type(3)
                        p
                            color #21BDCC
                    &:nth-of-type(4)
                        p
                            color #FA8436
                    &:nth-of-type(5)
                        p
                            color #866BEE
                    &:nth-of-type(6)
                        p
                            color #71C6B0
                    &:nth-of-type(7)
                        p
                            color #32C5FF
                    &:nth-of-type(8)
                        p
                            color #6DD400
            .matchingInfo
                dt
                    margin 10rpx 15rpx
                    font-size 16rpx
                    line-height 16rpx
                    color #333333
                    overflow hidden
                    span,p
                        float left
                    span
                        font-size 14rpz
                        color #979EA7
                dd
                    padding 0 11rpx
                    height calc(100% - 36rpx)
                    overflow scroll
                    -webkit-overflow-scrolling: touch;
                    div
                        float left
                        margin 0 4rpx 8rpx 4rpx
                        width calc(50% - 8rpx)
                        heihgt 50rpx
                        padding 10rpx
                        border 1px solid #D7D7D7
                        .name
                            overflow hidden
                            line-height 16rpx
                            strong
                                font-size 12rpx
                                color #333333
                        .value
                            margin 5rpx 0
                            span
                                height 16rpx
                                font-size 12rpx
                                padding 0 5rpx
                            .amount
                                color #5588F1
                                margin-right 10rpx
                                background rgba(85,136,241,0.1)
                            .waterContent
                                color #21BC9A
                                background rgba(33, 188, 154, 0.1)
                        .materialScience
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 12rpx
                            color #666666
    footer
        display flex
        justify-content space-between
        height 70rpx
        padding 15rpx
        &.hideOpinion
            display block
            >div
                width 100%
                button
                    width 50%
        button
            width 50%
            height 40rpx
            font-size 16rpx
        .opinionButton
            width 100rpx
            background #5588F1
            border none
            color #fff
            border-radius 4rpx
        div
            button
                width 110rpx
                height 40rpx
                line-height 38rpx
                background #fff
                font-size 16rpx
                color #E50C0D
                border 1px solid #E50C0D
                &:before
                    padding-right 5rpx
                &:nth-of-type(1)
                    border-radius 4rpx 0 0 4rpx
                &:nth-of-type(2)
                    background #E50C0D
                    color #fff
                    border-radius 0 4rpx 4rpx 0
    .van-popup
        border-radius 4px
        overflow hidden
    .selectCrew
        width 345rpx
        h3
            font-size 14rpx
            line-height 30rpx
            height 30rpx
            text-align center
            color #fff
            background linear-gradient(315deg,rgba(85,167,254,1) 0%, rgba(62,121,197,1) 100%)
        ul
            padding 15rpx
            padding-bottom 0
            max-height 320rpx
            overflow scroll
            -webkit-overflow-scrolling touch
            li
                width 100%
                height 75px
                overflow hidden
                border-radius 4px
                margin-bottom 10rpx
                border 1px solid rgba(215,215,215,1)
                .cornerMarker
                    position absolute
                    width 40rpx
                    height 40rpx
                    top 0
                    right 0
                    color #979EA7
                    &:before
                        font-size 40rpx
                        line-height 40rpx
                        position absolute
                        top 0
                    i
                        font-size 16rpx
                        font-weight 600
                        position absolute
                        top 4rpx
                        right 4rpx
                        color #fff
                .crewName
                    width 40rpx
                    height 100%
                    background #F0F7FF
                    color #333333
                    position relative
                    .cornerMarker
                        width 30rpx
                        height 30rpx
                        left 0
                        right auto
                        color #E2ECF8
                        &:before
                            font-size 30rpx
                            line-height 30rpx
                        i
                            font-size 12rpx
                            left 3rpx
                            top 3rpx
                            right auto
                            color #AFBED1
                    .name
                        display inline-block
                        width 100%
                        font-size 13rpx
                        padding 8rpx
                        text-align center
                        position absolute
                        left 50%
                        top 50%
                        transform translate(-50%, -50%)
                .crewDetails
                    width calc(100% - 40rpx)
                    height 100%
                    padding 8rpx 14rpx
                    position relative
                    p
                        overflow hidden
                        i,span
                            float left
                        i
                            margin 5rpx 5rpx 0 0
                            width 16rpx
                            height 16rpx
                            background url(./../../../assets/images/icons/icon_gy_1.png) no-repeat
                            background-size auto 100%
                        span
                            width calc(100% - 30rpx)
                            overfloe hidden
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            line-height 26rpx
                            color #333333
                    .cornerMarker
                        i
                            font-size 10rpx
                            top 8rpx
                            right -2rpx
                            color #fff
                            font-weight 100
                            transform rotate(45deg)
                &.active
                    border 2px solid #54A5FB
                    .crewName
                        background #3495FB
                        color #fff
                    .cornerMarker_l
                        color #027DFE
                        i
                            color #fff
                &.associated
                    .cornerMarker_r
                        color #FA8436
        .btns
            margin-top 15rpx
            height 50rpx
            text-align center
            button
                border none
                font-size 14rpx
                color #fff
                width 80px
                height 34px
                background linear-gradient(135deg,rgba(58,150,254,1) 0%, rgba(64,182,255,1) 100%)
                border-radius 4px
</style>
